import { postMessageToRN } from '../RNCommunicator/postMessageToRN.util';
import { getAppURL } from '../getter/getAppURL.util';

export const requestAppUpdate = (Popup: any) => {
  Popup.alert({
    title: '업데이트가 필요해요!',
    content: '원활한 사용을 위해 스토어에서\n업데이트를 해주세요!',
    buttonArray: [
      {
        text: '확인',
        color: 'blue',
        onClick: () => {
          postMessageToRN({ messageKey: 'link', messageParam: getAppURL()! });
        },
      },
    ],
  });
};
